// Head Counselor email lookup table
// Email pattern: headcounselor{groupcode_lowercase}@campersnapshot.com

const HEAD_COUNSELOR_EMAILS = {
  B01: { name: "Lobsters",          email: "headcounselorb01@campersnapshot.com" },
  B02: { name: "Sharks",             email: "headcounselorb02@campersnapshot.com" },
  B03: { name: "Scorpions",           email: "headcounselorb03@campersnapshot.com" },
  B04: { name: "Gators",             email: "headcounselorb04@campersnapshot.com" },
  B05: { name: "Crocodiles",         email: "headcounselorb05@campersnapshot.com" },
  B06: { name: "Squids",             email: "headcounselorb06@campersnapshot.com" },
  B07: { name: "Mussels",            email: "headcounselorb07@campersnapshot.com" },
  B08: { name: "Mackerals",          email: "headcounselorb08@campersnapshot.com" },
  B09: { name: "Walrus",             email: "headcounselorb09@campersnapshot.com" },
  B10: { name: "Stingrays",          email: "headcounselorb10@campersnapshot.com" },
  B11: { name: "Eels",               email: "headcounselorb11@campersnapshot.com" },
  B12: { name: "Swordfish",          email: "headcounselorb12@campersnapshot.com" },
  B13: { name: "Barracudas",         email: "headcounselorb13@campersnapshot.com" },
  B14: { name: "Orcas",              email: "headcounselorb14@campersnapshot.com" },
  B15: { name: "Kingfish",           email: "headcounselorb15@campersnapshot.com" },
  G01: { name: "Starfish",           email: "headcounselorg01@campersnapshot.com" },
  G02: { name: "Seals",              email: "headcounselorg02@campersnapshot.com" },
  G03: { name: "Pelicans",           email: "headcounselorg03@campersnapshot.com" },
  G04: { name: "Angelfish",          email: "headcounselorg04@campersnapshot.com" },
  G05: { name: "Scallops",           email: "headcounselorg05@campersnapshot.com" },
  G06: { name: "Catfish",            email: "headcounselorg06@campersnapshot.com" },
  G07: { name: "Snappers",           email: "headcounselorg07@campersnapshot.com" },
  G08: { name: "Oysters",            email: "headcounselorg08@campersnapshot.com" },
  G09: { name: "Puffins",            email: "headcounselorg09@campersnapshot.com" },
  G10: { name: "Marlins",            email: "headcounselorg10@campersnapshot.com" },
  G11: { name: "Manatees",           email: "headcounselorg11@campersnapshot.com" },
  G12: { name: "Sea Lions",          email: "headcounselorg12@campersnapshot.com" },
  G13: { name: "Swans",              email: "headcounselorg13@campersnapshot.com" },
  G14: { name: "Jewelfish",          email: "headcounselorg14@campersnapshot.com" },
  G15: { name: "Flamingos",          email: "headcounselorg15@campersnapshot.com" },
  N02: { name: "Minnows",            email: "headcounselorn02@campersnapshot.com" },
  N03: { name: "Guppies",            email: "headcounselorn03@campersnapshot.com" },
  N04: { name: "Ducklings",          email: "headcounselorn04@campersnapshot.com" },
  N05: { name: "Goldfish",           email: "headcounselorn05@campersnapshot.com" },
  N07: { name: "Otters",             email: "headcounselorn07@campersnapshot.com" },
  N08: { name: "Flounders",          email: "headcounselorn08@campersnapshot.com" },
  N10: { name: "Seahorses",          email: "headcounselorn10@campersnapshot.com" },
  N11: { name: "Turtles",            email: "headcounselorn11@campersnapshot.com" },
  N12: { name: "Penguins",           email: "headcounselorn12@campersnapshot.com" },
  N13: { name: "Dolphins",           email: "headcounselorn13@campersnapshot.com" },
  N14: { name: "Sailfish",           email: "headcounselorn14@campersnapshot.com" },
  N15: { name: "DragonFish",         email: "headcounselorn15@campersnapshot.com" },
  N16: { name: "Pufferfish",         email: "headcounselorn16@campersnapshot.com" },
};

// Also handle CIT groups and any unknown group codes dynamically
export function getHeadCounselorEmail(groupCode) {
  const upper = groupCode.toUpperCase().replace(/[-\s]/g, '');
  if (HEAD_COUNSELOR_EMAILS[upper]) {
    return HEAD_COUNSELOR_EMAILS[upper];
  }
  // Dynamic fallback: derive from group code
  const lower = groupCode.toLowerCase().replace(/[-\s]/g, '');
  return {
    name: groupCode,
    email: `headcounselor${lower}@campersnapshot.com`,
  };
}

export default HEAD_COUNSELOR_EMAILS;
